import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { datesorting, getCapitalized, getName, getProfileName, getSequnceSort, getUrlSegment, textTrim } from "../../utils/helper";
import { userEnrollmentCheck } from "../../redux/actions/APIs";
import { ShimmerThumbnail } from "react-shimmer-effects";
import { enrollModal } from "../../redux/actions";
const ChildEnrollmentPopUp = ({ closeModal, handleEnrollCourse, loader }) => {
	const dispatch = useDispatch();
	const { loggedInUser, defaultChildData, modalData, userEnrollmentData } = useSelector(
		(state) => state.collections
	);
	const [selectedUser, setSelectedUser] = useState();
	const [getAllUsers, setAllUsers] = useState([]);
	// console.log("selectedUser : ", selectedUser, modalData, userEnrollmentData, getAllUsers);

	useEffect(() => {
		let obj = {};
		if (getUrlSegment()[0] === "userplan") {
			obj = {
				parentId: loggedInUser?.id,
				planId: modalData.course[0]?.planId,
				courseId: "",
				isPlan: true,
			}
		} else {
			obj = {
				parentId: loggedInUser?.id,
				planId: "",
				courseId: modalData.course[0]?.id,
				isPlan: false,
			}
		}
		
		dispatch(userEnrollmentCheck(obj));
	}, [])

	useEffect(() => {
		if (userEnrollmentData?.records?.length > 0 && loggedInUser) {
			let userArr = [];
			datesorting(loggedInUser?.children)?.map((child, key) => {
				let getUserObj = userEnrollmentData?.records?.find((user, uKey) => user?.childId === child?.id);
				let Obj = { ...child, isEnrolled: getUserObj?.isEnrolled }
				userArr.push(Obj);
			})
			setSelectedUser(userArr[0]);
			setAllUsers(userArr);
		}
	}, [userEnrollmentData])


	const handleContinue = () => {
		modalData.course?.map((course, key) => {
			course.childId = selectedUser.id;
		})
		//	console.log("selectedUser @@@ : ", modalData);
		dispatch(enrollModal(modalData.course));
		closeModal();
	}

	const handleContinueByCourseCatlog = ()=>{
		if(modalData.course?.length > 0){
			modalData.course[0].childId = selectedUser.id;
			handleEnrollCourse(modalData.course);
			// closeModal();
		}
		
	}
	return (
		<div className="RootContent">
			<div className="smallpopup ">
				<div className="modal d-flex" id="schoolactivity2" role="dialog">
					<div className="modal-dialog modal-lg">
						<div className="modal-content my_popup">
							<div className="modal-header">
								<h2 className="flexone w-100">
									<span>Select A Learner For Enrollment</span>
									<button
										className="closebtn"
										data-dismiss="modal"
										onClick={() => closeModal()}
									>
										<i class="fa-regular fa-xmark"></i>
									</button>
								</h2>
							</div>

							<div className="modal-body paymentinfo p-0">
								{getAllUsers?.length > 0 ? (
									<div className="choose_profile">
										<div className="form-group  flexone w-100">
											<div className="flexone position-relative select_Profile_input w-100">
												<div
													aria-haspopup="true"
													className="pointer dropdownDiv flex w-100"
													aria-expanded="false"
													data-toggle="dropdown"
												>
													<div className={`Abotitems flextwo m-0 p-0 border-0 ${selectedUser?.isEnrolled && "disabledevent"}"`}>
														<div className="items_image mr-3">
															{selectedUser?.imageUrl ? (
																<span className=""><img src={selectedUser?.imageUrl} alt="" /></span>
															) : (
																<span className="ProfileChild">{getProfileName(selectedUser)}</span>
															)}
														</div>
														<div className="aboutitemsdtl">
															<p className="">{textTrim(getCapitalized(getName(selectedUser), 18))}</p>
														</div>
													</div>
													<div
														class="dropdwnicon pointer flexfive"
														href="#showUserPlan0"
														aria-expanded="true"
													>
														<i class="fa-regular fa-chevron-down"></i>
													</div>
												</div>
												<ul
													className="dropdown-menu dropdown-menu-end lPDropdwnList"
													aria-labelledby=""
												>
													{userEnrollmentData?.records?.length > 0 &&
														getAllUsers?.map((child, index) => (
															<li key={index} className={`${child?.isEnrolled && "disabledevent"}`}
																onClick={() => { !child?.isEnrolled && setSelectedUser(child) }}
															>
																{child?.imageUrl ? (
																	<span className="initilas_dropdwn"><img src={child?.imageUrl} alt="" /></span>
																) : (
																	<span className="initilas_dropdwn">{getProfileName(child)}</span>
																)}
																{textTrim(getCapitalized(getName(child), 18))}</li>
														))}

												</ul>
											</div>
										</div>
									</div>

								) : (
									<ShimmerThumbnail height={200} width={400} />
								)}
							</div>


							<div className="modal-footer">
								<div className="text-right">
									{loader ? (
										<button
												className=" mybutton"
												key={Math.random()}
												disabled
											>
												<span className="RounAnimation mr-1"></span>{" "}
												Please Wait...
										</button>
									): (
										<button type="button" className="mybutton" onClick={() =>{
										modalData?.type === "showLearnerEnrollPopUp" ? handleContinueByCourseCatlog() : handleContinue()}}
										disabled={selectedUser?.isEnrolled}
									>
										Continue
									</button>
									)}
									
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default ChildEnrollmentPopUp;
